import Header from './Header'
import Card from './Card'
import Corkboard from './Corkboard'
import MissionCard from './MissionCard'
import Chalkboard from './Chalkboard'
import EmailCard from './EmailCard'
import InteractivesArea from './InteractivesArea'
import Interactive from './Interactive'
import Nelson from './Nelson'
import { useState, useEffect } from 'react'

const Welcome = ({ onScreenUpdate }) => {
  const [dialogue, setDialogue] = useState(null)
  const [showDialogue, setShowDialogue] = useState(false)
  const [learnLink, setLearnLink] = useState(null)
  const [dialogueLinkText, setDialogueLinkText] = useState('Learn More')

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="mainContainer">
      <audio id="cheer" src="audio/fx/cheers_gift.mp3" />
      <audio id="snort" src="audio/fx/neighSnort.mp3" />
      <audio id="countin" src="audio/fx/CountinOnYou5.mp3" />

      <Header onScreenUpdate={onScreenUpdate} />
      <div className="chalkAndIconsAndCork">
        <div className="chalkAndIcons">
          <Chalkboard>
            <div className="chalkboardHeader LithosPro welcomeHeader ">
              Welcome to Equine Science 4 Kids!
            </div>
            <div className="chalkboardContent">
              <p>
                Would school be more fun if there were horses in your classroom?
                How about horses in your gym class? And even in your lunch room?
                Hey, it's not a dream! It's the Rutgers Equine Science Center.
              </p>
              <p>
                We go to school with horses every day! We've learned a lot about
                keeping them happy, healthy and strong, and keeping their
                environment clean. And now you can too. Just saddle up and click
                around!
              </p>
            </div>
          </Chalkboard>
          <InteractivesArea>
            <Interactive
              cat={'rewards'}
              itemName={'gift'}
              alt={'a wrapped gift'}
              url={'BlueRibbon.pdf'}
              sound={'cheer'}
              onClick={(speaking) => {
                setShowDialogue(speaking)
                setDialogue(
                  <div>
                    <p>We've got a free gift for you!</p>
                    <p>
                      Download and print out your own Equine Champion Pop-Up
                      Card (with help from your parents)!
                    </p>
                  </div>
                )
                setLearnLink('pages/rewards/BlueRibbon.pdf')
                setDialogueLinkText('Download Equine Champion Pop-Up Card')
              }}
            />
            <Interactive
              cat={'game'}
              itemName={'FunOnTheFarm_logo'}
              alt={'Fun on the Farm logo'}
              sound={'countin'}
              url={
                // 'https://esc.rutgers.edu/wp-content/themes/esc/pages/kids/games/farm/'
                'https://fotftest.netlify.app/'
              }
              onClick={(speaking) => {
                setShowDialogue(speaking)
                setDialogue(
                  <div>
                    <p>Let's Play a Game!</p>
                    <p>
                      In Fun on the Farm, you'll Learn more about life on a
                      farm!
                    </p>
                  </div>
                )
                setLearnLink(
                  // 'https://esc.rutgers.edu/wp-content/themes/esc/pages/kids/games/farm/'
                  'https://fotftest.netlify.app/'
                )
                setDialogueLinkText('Play Fun on the Farm Now!')
              }}
            />
            <Interactive
              cat={'game'}
              itemName={'exercisinghorsepower_logo'}
              alt={'Exercising Horsepower logo'}
              sound={'snort'}
              url={
                'https://esc.rutgers.edu/wp-content/themes/esc/pages/kids/games/exercise/'
              }
              onClick={(speaking) => {
                setShowDialogue(speaking)
                setDialogue(
                  <div>
                    <p>Let's Play a Game!</p>
                    <p>
                      In Exercising Horsepower, you'll learn about the science
                      used to keep horses healthy and active, helping run tests
                      on them as they run on a treadmill!
                    </p>
                  </div>
                )
                // setLearnLink(
                //   'https://esc.rutgers.edu/wp-content/themes/esc/pages/kids/games/exercise/'
                // )
                // setDialogueLinkText('Play Exercising Horsepower Now!')
                // replace the setLearnLink and setDialogueLinkText lines below with the ones above when the game is complete and available.

                setLearnLink('soon')
                setDialogueLinkText('Coming Soon! Learn more!')
              }}
            />
          </InteractivesArea>
        </div>
        <Corkboard onScreenUpdate={onScreenUpdate}>
          <MissionCard />
          <EmailCard />

          <Card className="linksCard">
            <div className="cardTitle linksTitle">Links</div>
            <div className="linksLink">
              <a
                href="/pages/main/nelsonBio.html"
                target="_blank"
                rel="noreferrer"
              >
                Bio
              </a>
            </div>
            <div className="linksLink">
              <a
                href="https://esc.rutgers.edu/blog/"
                target="_blank"
                rel="noreferrer"
              >
                Blog
              </a>
            </div>
            <div className="linksLink">
              <a
                href="pages/main/joinFanClub.html"
                target="_blank"
                rel="noreferrer"
              >
                Join the fanclub
              </a>
            </div>
          </Card>
        </Corkboard>
      </div>
      <Nelson
        showDialogue={showDialogue}
        dialogue={dialogue}
        setShowDialogue={setShowDialogue}
        learnLink={learnLink}
        dialogueLinkText={dialogueLinkText}
        setDialogueLinkText={setDialogueLinkText}
        onScreenUpdate={onScreenUpdate}
      />
    </div>
  )
}

export default Welcome
